import ConfirmationTemplate from "../../../templates/users/confirmation";

const ConfirmationScreen = () => {
  return <ConfirmationTemplate />;
};

export default ConfirmationScreen;
